import React from 'react';
import PropTypes from 'prop-types';
import {Box, IconButton} from '@mui/material';
import {
    FirstPage as FirstPageIcon,
    KeyboardArrowLeft,
    KeyboardArrowRight,
    LastPage as LastPageIcon,
} from '@mui/icons-material';
import {ezprOrange} from './_helpers';

const ICON_SX_ENABLED = Object.freeze({color: '#666', fontSize: '20px'});
const ICON_SX_DISABLED = Object.freeze({color: '#CCC', fontSize: '20px'});


/**
 * @param {PaginationActions.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function PaginationActions(props) {
    const {count, page, rowsPerPage, onPageChange} = props;

    const getIconSx = (disabled) =>
        disabled ? ICON_SX_DISABLED : ICON_SX_ENABLED;

    const atFirst = page === 0;
    const atLast = page >= Math.ceil(count / rowsPerPage) - 1;

    const from = page * rowsPerPage + 1;
    const to = Math.min(count, (page + 1) * rowsPerPage);

    return (
        <Box sx={{display: 'flex', alignItems: 'center', whiteSpace: 'nowrap'}}>
            <IconButton onClick={(e) => onPageChange(e, 0)} disabled={atFirst}>
                <FirstPageIcon sx={getIconSx(atFirst)} />
            </IconButton>

            <IconButton onClick={(e) => onPageChange(e, page - 1)} disabled={atFirst}>
                <KeyboardArrowLeft sx={getIconSx(atFirst)} />
            </IconButton>

            <Box
                component="span"
                sx={{
                    mx: 1.5,
                    fontSize: 14,
                    fontWeight: 500,
                    color: '#333',
                    display: 'inline-flex',
                    alignItems: 'center',
                }}
            >
                <Box component="span" sx={{color: ezprOrange}}>{from}</Box>
                <Box component="span" sx={{mx: 0.5, color: ezprOrange}}>–</Box>
                <Box component="span" sx={{color: ezprOrange}}>{to}</Box>
                {'\u00A0of\u00A0'}
                <Box component="span">{count}</Box>
            </Box>

            <IconButton onClick={(e) => onPageChange(e, page + 1)} disabled={atLast}>
                <KeyboardArrowRight sx={getIconSx(atLast)} />
            </IconButton>

            <IconButton
                onClick={(e) => onPageChange(e, Math.max(0, Math.ceil(count / rowsPerPage) - 1))}
                disabled={atLast}
            >
                <LastPageIcon sx={getIconSx(atLast)} />
            </IconButton>
        </Box>
    );
}

PaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
};
